import React from "react";
import { HomeCharts, PatientActionItems, ActiveClaims, ClaimSearch, AddWebkey, ErrorBoundary } from "..";


import {
    useQuery,
    gql
  } from "@apollo/client";
  
function Home() {

  return (
    <>
        <div>
            <div className="body-content">
                <div className="container" style={{maxWidth:"max-content"}}>
                    <ErrorBoundary>
                        <HomeCharts/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <PatientActionItems/>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <AddWebkey></AddWebkey>
                    </ErrorBoundary>
                    <ErrorBoundary>
                        <ClaimSearch></ClaimSearch>
                    </ErrorBoundary>
                    
                </div>
            </div>
        </div>
    </>
  );
}

//

export default Home;
